module.exports = __webpack_public_path__ + "static/media/aid-blood-drop-svgrepo-com.1d3fc46d.svg";